<!-- 销售器械订单数据操作 -->
<template>
    <div>
        <div v-if="isLoaded">
            <div class="demo-drawer__content data_action_form">
                <el-card class="box-card" body-style="padding:0;border:1px solid #E4E7ED" v-if="tabForm">
                    <v-tabs :type="dataActionBox.actionType" :activeName="showTabs" :name="'jciName'" :value="'jciName'" :tabslist="tabForm" @tabs="(val) => { showTabs = val }" @tabHeight="tabHeight">
                        <template slot="tabs" slot-scope="scope">
                            <div class="table_content_box">
                                <!-- 主要信息 -->
                                <div v-if="scope.index == 0">
                                    <el-form label-width="120px" id="mainInfo" class="baseForm" :model="sendDataInfo" ref="sendDataInfo" size="mini" :show-message="false">
                                        <el-row v-if="dataActionBox.actionType != 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey" :prop="formOneValue.entityField" :rules="$common.getFormItemRules(formOneValue, sendDataInfo)">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="$common.htmlLabel(formOneValue.showField)"></label>
                                                    <!-- 日期 -->
                                                    <el-date-picker v-if="formOneValue.entityField == 'disTime'" v-model="sendDataInfo[formOneValue.entityField]" type="date" placeholder="选择日期" format="yyyy 年 MM 月 dd 日"
                                                        value-format="timestamp">
                                                    </el-date-picker>
                                                    <df-date v-else-if="formOneValue.fieldType == 'date'" v-model="sendDataInfo[formOneValue.entityField]"
                                                        :isdisabled="(sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0) || formOneValue.isChange == 0 ? true : false" :isShowLong="false">
                                                    </df-date>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.entityField == 'coName'" class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable @input="$common.clearSearch(sendDataInfo, formOneValue.setField,formOneValue.entityField)" @clear="$common.clearSearch(sendDataInfo, formOneValue.setField)"
                                                            v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField)"
                                                            :disabled="sendDataInfo.woApplyDetails.length > 0 ? true : false">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                :disabled="sendDataInfo.woApplyDetails.length > 0 ? true : false">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- 检索方案 -->
                                                    <el-tooltip v-else-if="formOneValue.fieldType == 'search'" class="item"
                                                        :disabled="sendDataInfo[formOneValue.entityField] == null || sendDataInfo[formOneValue.entityField] == '' ? true : false || sendDataInfo[formOneValue.entityField].length <= 9"
                                                        effect="dark" :content="sendDataInfo[formOneValue.entityField]" placement="bottom-start">
                                                        <el-input clearable @input="$common.clearSearch(sendDataInfo, formOneValue.setField,formOneValue.entityField)" @clear="$common.clearSearch(sendDataInfo, formOneValue.setField)"
                                                            v-model="sendDataInfo[formOneValue.entityField]" :ref="formOneValue.entityField" :id="formOneValue.entityField"
                                                            @keyup.enter.native="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField)"
                                                            :disabled="(formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)) && (sendDataInfo[formOneValue.entityField] ? true : false)">
                                                            <el-button @click="openSearch(formOneValue.searchId, formOneValue.isIndex, formOneValue.entityField, formOneValue.setField)" slot="append" icon="el-icon-search"
                                                                :disabled="(formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)) && (sendDataInfo[formOneValue.entityField] ? true : false)">
                                                            </el-button>
                                                        </el-input>
                                                    </el-tooltip>
                                                    <!-- formatter下拉选-->
                                                    <el-select clearable size="mini" v-else-if="formOneValue.fieldType == 'formatter'" @visible-change="selectChange"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)" @change="$forceUpdate()"
                                                        v-model="sendDataInfo[formOneValue.entityField]" placeholder="请选择">
                                                        <el-option v-for="item in JSON.parse(formOneValue.formatterContent)" :key="item.key" :label="item.key" :value="item.value">
                                                        </el-option>
                                                    </el-select>
                                                    <!-- 账期 -->
                                                    <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex)" type="number" v-else-if="formOneValue.entityField == 'credit'"
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)"
                                                        v-model="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                    <!-- string类型 -->
                                                    <el-input @keyup.enter.native="nextFocus(formOneValue.isIndex)" v-else
                                                        :disabled="formOneValue.isChange == 0 || (sendDataInfo.woApplyDetails.length > 0 && dataActionBox.actionType == 0 && formOneValue.isUpdate == 0)"
                                                        v-model.trim="sendDataInfo[formOneValue.entityField]" :maxlength="$store.state.inputLength"></el-input>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                        <el-row v-if="dataActionBox.actionType == 2">
                                            <template v-for="(formOneValue, formOneKey) in scope.row.jurconfigform">
                                                <el-form-item v-if="formOneValue.isShow == 1" :key="formOneKey">
                                                    <label slot="label" :style="$common.labelStyle(formOneValue.showField)" v-html="formOneValue.showField + ':'"></label>
                                                    <span v-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo[formOneValue.riftField])">{{sendDataInfo[formOneValue.entityField] }}</a>
                                                    </span>
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo[formOneValue.entityField]">
                                                            {{$common.getLocalTime(sendDataInfo[formOneValue.entityField])}}
                                                        </span>
                                                    </span>
                                                    <span v-else-if="formOneValue.entityField == 'isWms'">{{sendDataInfo.isWms== 1 ? '是' : '否' }}</span>
                                                    <span v-else-if="formOneValue.fieldType == 'formatter'">
                                                        {{getValue(sendDataInfo[formOneValue.entityField],formOneValue.entityField, formOneValue.fieldType,formOneValue.formatterContent) }}
                                                    </span>
                                                    <span v-else>{{ sendDataInfo[formOneValue.entityField] }}</span>
                                                </el-form-item>
                                            </template>
                                        </el-row>
                                    </el-form>

                                    <!-- 明细操作 -->
                                    <div id="operateBtn" v-if="dataActionBox.actionType != 2">
                                        <el-button type="primary" size="mini" @click="addDetail('sendDataInfo')">
                                            新增明细</el-button>
                                        <el-button type="primary" size="mini" @click="deleteDetails()" :disabled="sendDataInfo.woApplyDetails.length < 1">删除明细</el-button>
                                        <el-button type="primary" size="mini" @click="openStockRegisterBox()">缺货登记
                                        </el-button>
                                        <el-button type="primary" size="mini" @click="openPriceApplicationBox()">
                                            特价申请</el-button>
                                        <el-button type="primary" size="mini" @click="openAddress">维护客户地址
                                        </el-button>
                                        <el-button type="primary" size="mini" @click="lookLicence()">查看证照
                                        </el-button>
                                        <el-button @click="openExtSearch('1721092115898', 'conmId')" :disabled="dataActionBox.actionType == 1" type="primary" size="mini">提取销售合同</el-button>
                                        <el-button v-if="tabForm[0].isExtract == 1" type="primary" size="mini" :disabled="dataActionBox.actionType == 1" @click="openExtSearch('629899519725568')">提取外部订单</el-button>
                                        <el-button @click="exportTemplate" size="mini" type="primary">下载模版</el-button>
                                        <el-button @click="importDetails" size="mini" type="primary">导入明细</el-button>
                                        <el-button @click="UDIclick('sendDataInfo')" size="mini" type="primary">UDI扫码</el-button>
                                        <el-button type="primary" size="mini" :disabled="dataActionBox.actionType == 1" @click="openExtSearch('5214106197263729')">提取入库单</el-button>

                                        <el-dropdown style="margin-left: 5px;" v-if="$store.state.btnlist" trigger="click">
                                            <el-button type="primary">
                                                辅助功能<i class="el-icon-arrow-down el-icon--right"></i>
                                            </el-button>
                                            <template #dropdown>
                                                <el-dropdown-menu slot="dropdown">
                                                    <el-dropdown-item v-for="(item, index) in JSON.parse($store.state.btnlist)" :key="index" @click.native="Historical(item.mdSource, item.mdName)">{{
                                             item.mdName }}</el-dropdown-item>
                                                </el-dropdown-menu>
                                            </template>
                                        </el-dropdown>
                                        <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                            (Alt+F1：新增明细</el-link>
                                        <el-link :underline="false" type="danger" style="margin-left: 10px;">
                                            Alt+F2：删除明细)</el-link>

                                    </div>
                                    <!-- 明细信息 -->
                                    <el-table class="baseTable" v-if="mxForm" ref="mxTableRef" :data="sendDataInfo.woApplyDetails" :row-class-name="rowClassName" :row-style="rowStyle" @row-click="clickEvent"
                                        @selection-change="handleSelectionChange" border size="mini" :height="mxHeight">
                                        <el-table-column width="80" label="选择" v-if="dataActionBox.actionType != 2">
                                            <template slot-scope="scope">
                                                <el-radio v-model="selectedDetailsIndex" :label="scope.$index" border size="mini">
                                                    <i class="el-icon-thumb"></i>
                                                </el-radio>
                                            </template>
                                        </el-table-column>
                                        <el-table-column type="index" width="50" label="序号"> </el-table-column>
                                        <template v-for="(formOneValue, formOneKey) in mxForm.jurconfigform">
                                            <el-table-column :prop="formOneValue.entityField" :label="formOneValue.showField" :key="formOneKey" v-if="formOneValue.isShow == 1" :min-width="formOneValue.fieldWeight" show-overflow-tooltip>
                                                <template slot-scope="scope">
                                                    <!-- 显示通用名称 -->
                                                    <el-input @clear="clearChange(scope.$index, formOneValue.entityField)" :ref="formOneValue.entityField" v-if="formOneValue.entityField == 'bgmName' && dataActionBox.actionType != 2"
                                                        clearable @keyup.enter.native="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField, formOneValue.setField)"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                        <el-button @click="openSearch(formOneValue.searchId, scope.$index, formOneValue.entityField, '', formOneValue.focusField, formOneValue.nosetField, formOneValue.setField)" slot="append"
                                                            icon="el-icon-search"></el-button>
                                                    </el-input>
                                                    <span v-else-if="formOneValue.isRift == 1">
                                                        <a @click="toDetail(sendDataInfo.woApplyDetails[scope.$index][formOneValue.riftField])">{{sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]}}</a>
                                                    </span>
                                                    <!-- 生产日期 -->
                                                    <span v-else-if="formOneValue.fieldType == 'date'">
                                                        <span v-if="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                            {{$common.getLocalTime(sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField])}}
                                                        </span>
                                                    </span>
                                                    <!-- 数量 -->
                                                    <el-input @mousewheel.native.prevent @blur="blurwoadPnumber(5,scope.$index,formOneValue.entityField, formOneValue.focusField)"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.entityField == 'woadPnumber' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" @input="calculatePrice(5, scope.$index)" type="number"
                                                        v-model.number="sendDataInfo.woApplyDetails[scope.$index].woadPnumber"></el-input>
                                                    <!-- 含税价格 -->
                                                    <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.entityField == 'psprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number"
                                                        :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @blur="doCheckPrice(2, scope.$index,formOneValue.entityField, formOneValue.focusField)"
                                                        @input="calculatePrice(2, scope.$index)" v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>

                                                    <!-- 单价 -->
                                                    <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.entityField == 'price' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number"
                                                        :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(1, scope.$index)"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>

                                                    <!-- 总金额 -->
                                                    <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.entityField == 'money' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" type="number"
                                                        :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(3, scope.$index)"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>

                                                    <!-- 含税金额 -->
                                                    <el-input @mousewheel.native.prevent v-else-if="formOneValue.entityField == 'psmoney' && dataActionBox.actionType != 2 && formOneValue.isChange == 1"
                                                        @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField" type="number"
                                                        :disabled="sendDataInfo.woApplyDetails[scope.$index].woadPnumber <= 0" @input="calculatePrice(4, scope.$index)"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>
                                                    <!-- 折前价格 -->
                                                    <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(5, scope.$index)" :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.entityField == 'disPreprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>
                                                    <!-- 含税原价 -->
                                                    <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(8, scope.$index)" :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.entityField == 'orPsprice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>
                                                    <!-- 不含税原价 -->
                                                    <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField,scope.$index)" @input="calculatePrice(9, scope.$index)" :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.entityField == 'orPrice' && dataActionBox.actionType != 2 && formOneValue.isChange == 1" :maxlength="$store.state.inputLength" type="number"
                                                        v-model="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>
                                                    <!-- 备注 -->
                                                    <el-input @mousewheel.native.prevent @keyup.enter.native="tableNextFocus(formOneValue.focusField, scope.$index)" :ref="formOneValue.entityField"
                                                        v-else-if="formOneValue.entityField == 'woadRemark' && dataActionBox.actionType != 2" v-model.trim="sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]">
                                                    </el-input>
                                                    <!-- 是否集采 -->
                                                    <span v-else>
                                                        {{sendDataInfo.woApplyDetails[scope.$index][formOneValue.entityField]}}
                                                    </span>
                                                </template>
                                            </el-table-column>
                                        </template>
                                    </el-table>
                                </div>
                            </div>
                        </template>
                    </v-tabs>
                </el-card>
                <v-foot :actionType="dataActionBox.actionType" :footForm="footForm" :btnFlag="true" :sendDataInfo="sendDataInfo" @initActionBox="initActionBox" @sendDataAction="sendDataAction" @showPrintPlan="showPrintPlan"></v-foot>
            </div>
            <el-dialog title="缺货登记" :visible.sync="stockRegisterBox" width="500px" center top="2rem" :modal-append-to-body='true' :append-to-body="true">
                <el-form label-position="top" label-width="200px" size="mini">
                    <el-form-item label="客户">
                        <el-input v-model="stockRegisterData.cmName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="商品">
                        <el-input v-model="stockRegisterData.bgmName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="缺货数量">
                        <el-input v-model="stockRegisterData.wolrRegnumber"></el-input>
                    </el-form-item>
                    <el-form-item label="备注说明">
                        <el-input v-model="stockRegisterData.wolrRemark"></el-input>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="stockRegisterBox = false">取 消</el-button>
                    <el-button type="primary" @click="addShortageRegistration">确 定</el-button>
                </span>
            </el-dialog>
            <el-dialog title="特价申请" :visible.sync="priceApplicationBox" width="60%" center top="2rem" :modal-append-to-body='true' :append-to-body="true">
                <el-form label-position="right" label-width="160px" size="mini">
                    <el-form-item label="销售单位">
                        <el-input v-model="priceApplicationData.cmName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="商品">
                        <el-input v-model="priceApplicationData.bgmName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="批号">
                        <el-input v-model.trim="priceApplicationData.batchno" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="货主">
                        <el-input v-model.trim="priceApplicationData.coName" disabled></el-input>
                    </el-form-item>
                    <el-form-item label="生产日期">
                        <el-date-picker v-model="priceApplicationData.prodate" disabled type="date" placeholder="生产日期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="有效期">
                        <el-date-picker v-model="priceApplicationData.expidate" disabled type="date" placeholder="有效期" format="yyyy 年 MM 月 dd 日" value-format="timestamp">
                        </el-date-picker>
                    </el-form-item>
                    <el-form-item label="申请售价">
                        <el-input type="number" v-model="priceApplicationData.wosaAppprice"></el-input>
                    </el-form-item>
                    <el-form-item label="申请原因">
                        <el-input v-model.trim="priceApplicationData.wosaAppreason"></el-input>
                    </el-form-item>
                    <el-form-item label="申请截止日期">
                        <el-date-picker v-model="priceApplicationData.wosaEnddate" type="date" placeholder="有效期" format="yyyy 年 MM 月 dd 日" value-format="timestamp" @change="changeTime(priceApplicationData.wosaEnddate)">
                        </el-date-picker>
                    </el-form-item>
                </el-form>
                <span slot="footer" class="dialog-footer">
                    <el-button @click="priceApplicationBox = false">取 消</el-button>
                    <el-button type="primary" @click="addSpecialPriceApply">确 定</el-button>
                </span>
            </el-dialog>
        </div>
        <printPlan ref="printPlan"></printPlan>
        <customerAddress ref="customerAddress"></customerAddress>
        <el-dialog :title="seTitle" v-if="DialogVisible" :visible.sync="DialogVisible" :width="seWidth" :modal-append-to-body='true' :append-to-body="true" @close="closeChild">
            <SearchSchemeOther ref="SearchSchemeOther" :isRepetition="isRepetition" :isRepetitionList="isRepetitionList" :isProp="'bgsId'" :id="seId" :parentSearchData="parentSearchData" @TranData="changeInputModel" @getWidth="getSeWidth"
                @sendTitle="getSearchName" />
        </el-dialog>
        <el-dialog :title="exTitle" v-if="DialogExtract" :visible.sync="DialogExtract" :width="exWidth" :modal-append-to-body='true' :append-to-body="true">
            <ExtractionScheme ref="extractionScheme" :interceptFlag='interceptFlag' :id="exId" :ppId="ppId" :cmId="cmId" @TranData="getDataByChen" @getWidth="getWidth" @sendTitle="getExtractName" />
        </el-dialog>
        <el-dialog title="提示" v-if="showDialog" :visible.sync="showDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="dialogList" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
                <el-table-column prop="validity" label="有效期" min-width="100">
                    <template slot-scope="{row}">
                        {{ $common.getLocalTime(row.validity) }}
                    </template>
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="提示" :visible.sync="showCmSustateDialog" width="70%" :modal-append-to-body="true" :append-to-body="true">
            <el-table :data="[{level: 0, data: cmSustateRemark}]" border style="width: 100%">
                <el-table-column prop="level" label="类型" width="50">
                    <template slot-scope="{row}">
                        <span :style="row.level == 0 ? 'color:red' : 'color:#ffd04b'">
                            {{ row.level == 0 ? "拦截" : '预警' }}
                        </span>
                    </template>
                </el-table-column>
                <el-table-column prop="data" label="内容" min-width="180">
                </el-table-column>
            </el-table>
            <span slot="footer" class="dialog-footer">
                <el-button size="mini" type="primary" @click="showCmSustateDialog = false">确 定</el-button>
            </span>
        </el-dialog>
        <el-dialog title="导入" v-if="importShow" :visible.sync="importShow" width="30%" append-to-body modal-append-to-body>
            <initDataUpload v-if="importShow" :parentSearchData="importObj" :url="url" :importType="importType" @fileSuccess='fileSuccess' @closeExcel="closeExcel">
            </initDataUpload>
        </el-dialog>
        <component :is="currentComponent" :ref="currentComponent"></component>
        <div v-show="false">{{ some }}</div>
        <el-dialog class="dialogBox" title="UDI扫码" v-if="UDIshow" :visible.sync="UDIshow" width="95vw" :modal-append-to-body='true' :append-to-body="true" top="10px">
            <salesUDIscanCode :actionData="UDIobj" @clearClick="clearClick"></salesUDIscanCode>
        </el-dialog>
        <operSelect ref="operSelect" @drawerCancel="drawerCancel" @conAdd="conAdd"></operSelect>
    </div>
</template>

<script>
//这里可以导入其他文件（比如：组件，工具js，第三方插件js，json文件，图片文件等等）
//例如：import 《组件名称》 from '《组件路径》';
import NP from "number-precision";
import SearchScheme from "../byComponents/SearchScheme.vue";
import salesUDIscanCode from "../udi/salesUDIscanCode.vue";
import customerAddress from '@/components/customerAddress.vue';

export default {
    name: "salesInstrumentOrderAction",
    props: ["actionData"],
    //import引入的组件需要注入到对象中才能使用
    components: {
        SearchScheme,
        salesUDIscanCode,
        customerAddress
    },
    data() {
        //这里存放数据
        return {
            currentComponent: "",
            historicalOrder: {
                cmName: "",
                cmId: "",
                bgmName: "",
                bgmId: "",
            },
            //----------------------------
            showDialog: false,
            showDialog1: false,
            flags: false,
            flag: -1,
            blurData: "",
            dialogList: [],
            focusIndex: "",
            dictionariesDatas: [], //配送方式
            detailRules: false, //规则
            ruleDisabled: false,
            dataActionBox: {
                showStatus: false,
                openMode: "ltr" || "rtl",
                boxTitle: "新增" || "编辑",
                actionType: 0, // 0新增，1修改
            },
            sendDataInfo: {},
            inputel: "", //所有input对象
            detaislDataInfo: {
                //初始单条明细
                bgmId: "", //商品
                bgmName: "",
                batchno: "", //批号
                bgsId: "", //库存id
                costPrice: 0, //成本价
                costMoney: 0, //含税成本金额
                costAmount: 0, //成本金额-+
                expidate: "", //有效期
                gross: 0, //毛利
                lotno: "", //批次
                num: 0, //当前库存数量
                outRate: 0, //销项税率
                prodate: "", //生产
                sterBatchno: "", //灭菌批号
                woadPnumber: 0, //销售数量
                woadRemark: "", //备注
                money: 0, //金额
                price: 0, //单价
                psmoney: 0, //含税金额
                psprice: 0, //含税价格
                woadReserves1: "", //预留字段
                woadReserves2: "",
                woadReserves3: "",
                woadReserves4: "",
                woadReserves5: "",
                woadReserves6: "",
                bgiType: "",
                woadWcost: 0,
            },
            showTabs: "",
            formDataList: [],
            dictionariesData: {},
            // userOneList:[],
            selectedDetailsIndex: 0,
            // 缺货登记
            stockRegisterBox: false,
            stockRegisterData: {
                bgmId: "",
                bgmName: "",
                cmId: "",
                cmName: "",
                wolrRegnumber: "",
                wolrRemark: "",
            },
            storageRoomList: [], //库房
            // 特价申请
            priceApplicationBox: false,
            priceApplicationData: {
                bgmId: "", //商品
                bgmName: "",
                coId: "", //货主
                coName: "",

                wosaSalecus: "",
                cmId: "",
                cmName: "",
                wosaAppprice: "", // 申请售价
                wosaAppreason: "", // 申请原因
                batchno: "", // 批号
                expidate: "", // 	有效期
                wosaEnddate: "", // 申请截止日期
                wosaMinprice: "", // 最低售价
                prodate: "", // 	生产日期
                acType: 0, // 0自动提交，1手动提交
            },
            editDateilsIndex: "",
            giftsList: [],
            seTitle: "", //检索
            DialogVisible: false,
            seId: 0,
            cmId: "",
            ormId: "",
            coId: 0,
            seType: "",
            seIndex: 0,
            levleId: 0,
            seWidth: "0",
            mxHeight: 0,
            isLoaded: false,
            pageType: "one",
            parentSearchData: {
                orderType: 1, //	订单类型0.药品1.器械
            },
            selectedRow: [], // 当前已选择行
            mainFormList: [], //过滤的主表单
            tabForm: [], // tab循环的主表单
            mxForm: [],
            footForm: [],
            sField: "", // 赋值字段
            fField: "", //焦点字段
            nosField: "", // 不可赋值字段
            interceptFlag: false,//提取是否拦截
            DialogExtract: false, //提取
            exId: "",
            exTitle: "",
            exWidth: "",
            ppId: "orderId",
            some: 0,
            setField: "",
            isRepetitionList: [],
            isRepetition: false,
            //---------------------------------
            UDIshow: false,
            UDIobj: {},
            UDIlist: [],
            importShow: false,
            importType: "",
            url: "",
            importObj: {
                coId: "",
                stId: "",
            },
            cmSustate: null,
            cmSustateRemark: "",
            showCmSustateDialog: false,
            actionButtonId: '',
        };
    },
    //监听属性 类似于data概念
    computed: {},
    //监控data中的数据变化
    watch: {
        "sendDataInfo.stName": {
            handler: function (newstr, oldValue) {
                if (!newstr) {
                    this.sendDataInfo.stId = "";
                }
            },
            deep: true,
        },
        "sendDataInfo.woApplyDetails": {
            handler: function (newValue, oldValue) {
                // 初始化总计值
                this.sendDataInfo.totalCount = newValue ? newValue.length : 0;
                this.sendDataInfo.totalMoney = 0;
                this.sendDataInfo.totalNumber = 0;

                // 如果是空数组或未定义，直接设置并返回
                if (!newValue || newValue.length === 0) {
                    if (this.detailRules) {
                        this.ruleDisabled = false;
                    }
                    return;
                }

                // 预定义需要更新的字段，避免重复遍历对象属性
                const fieldsToUpdate = ['disPreprice', 'woadPnumber', 'price', 'psprice', 'orPsprice', 'orPrice'];

                // 一次性遍历，同时处理字段更新和总计计算
                for (let i = 0; i < newValue.length; i++) {
                    const item = newValue[i];

                    // 处理null和"null"值
                    for (let key in item) {
                        if (item[key] == null || item[key] == "null") {
                            this.sendDataInfo.woApplyDetails[i][key] = "";
                        }
                    }

                    // 批量更新指定字段
                    fieldsToUpdate.forEach(field => {
                        if (item.hasOwnProperty(field)) {
                            this.$set(item, field, this.$common.updataNum(field, item)[field]);
                        }
                    });

                    // 累加计算总数和总金额
                    const psmoney = parseFloat(item.psmoney) || 0;
                    const woadPnumber = parseFloat(item.woadPnumber) || 0;

                    // 使用数值精度库进行安全计算，遵循数值计算安全规范
                    if (!isNaN(psmoney)) {
                        this.sendDataInfo.totalMoney = NP.plus(parseFloat(this.sendDataInfo.totalMoney), psmoney);
                    }
                    if (!isNaN(woadPnumber)) {
                        this.sendDataInfo.totalNumber = NP.plus(parseFloat(this.sendDataInfo.totalNumber), woadPnumber);
                    }
                }

                // 根据规则状态设置禁用状态
                if (this.sendDataInfo.totalCount > 0 && this.detailRules) {
                    this.ruleDisabled = true;
                } else {
                    this.ruleDisabled = false;
                }
            },
            deep: true,
        },
        "sendDataInfo.cmName": {
            handler: function (newValue, oldValue) {
                if (this.dataActionBox.actionType == 0) {
                    this.sendDataInfo.salesId = "";
                    this.sendDataInfo.salesName = "";
                    this.sendDataInfo.caiId = "";
                    this.sendDataInfo.caiAddress = "";
                    this.sendDataInfo.recId = "";
                    this.sendDataInfo.recName = "";
                }
            },
            deep: true,
        },
        "sendDataInfo.dismode": {
            handler: function (newstr, oldValue) {
                console.log(newstr, "dismodedismode")
                this.$nextTick(() => {
                    let newValue = newstr.replace(/\s*/g, "");
                    this.sendDataInfo.dismode = newValue;
                    if (newValue == "物流") {
                        // this.sendDataInfo.companyName = "";
                        // this.sendDataInfo.loId = "";
                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "companyName") {
                                item.isShow = 1;
                            }
                            if (item.entityField == "pickupName") {
                                item.isShow = 0;
                            }
                        });
                    } else if (newValue.includes("自提")) {
                        // this.sendDataInfo.pickupName = "";
                        // this.sendDataInfo.pickupId = "";
                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "pickupName") {
                                item.isShow = 1;
                                console.log(item, 'itemitem');
                            }
                            if (item.entityField == "companyName") {
                                item.isShow = 0;
                            }

                        });
                    } else {

                        this.tabForm[0].jurconfigform.forEach((item) => {
                            if (item.entityField == "companyName") {
                                this.sendDataInfo.companyName = "";
                                this.sendDataInfo.loId = "";
                                item.isShow = 0;
                            }
                            if (item.entityField == "pickupName") {
                                this.sendDataInfo.pickupName = "";
                                this.sendDataInfo.pickupId = "";
                                item.isShow = 0;
                            }
                        });
                    }
                    var index = 0
                    this.tabForm[0].jurconfigform.forEach(item => {
                        if (item.isShow == 1) {
                            item.isIndex = index
                            index++
                        }
                    })
                });
                this.some++;
                this.$forceUpdate();
            },
            deep: true,
        },
    },
    //方法集合
    methods: {
        // 触发组件的提交
        fileSuccess(val) {
        },
        // 关闭弹窗
        closeExcel(val) {
            this.importShow = false
            if (val.list.length > 0) {
                var list = []
                val.list.forEach(item => {
                    list.push({})
                    for (const key in item) {
                        this.$set(list[list.length - 1], key, item[key])
                    }
                })
                this.sendDataInfo.woApplyDetails.push(...list)
                this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                    this.calculatePrice(5, index)
                })
            }
        },
        exportTemplate() {
            window.location.href = `${window.global_config.BASE_URL}/woApply/downSuDetailExcel`
        },
        importDetails() {
            this.$refs['sendDataInfo'].validate((valid) => {
                if (valid) {
                    this.importType = 'exportSuDetail'
                    this.url = 'woApply/exportSuDetail'
                    this.importObj.stId = this.sendDataInfo.stId
                    this.importObj.coId = this.sendDataInfo.coId
                    this.importShow = true
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        UDIclick(sendDataInfo) {
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.UDIobj = {
                        data: this.sendDataInfo,
                        UDIlist: this.UDIlist || []
                    }
                    this.UDIshow = true
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });

        },
        clearClick(flag, val, list) {
            if (flag) {
                if (list.length > 0) {
                    this.UDIlist = list
                }else{
                    this.UDIlist = []
                }
                this.sendDataInfo.woApplyDetails = [];
                const numberList = this.mxForm.jurconfigform.filter((item) => item.fieldType == "number").map((item) => item.entityField);
                val.forEach((item, index) => {
                    item.woadPnumber = item.woadPnumber || 0
                    item.psmoney = item.psmoney || 0
                    item.money = item.money || 0
                    item.isTicket = Number(this.ticket) || ""
                    this.sendDataInfo.woApplyDetails.push({});
                    for (const key in this.detaislDataInfo) {
                        const index1 = numberList.findIndex(items => items == key);
                        if (index1 != -1 && !item[key]) {
                            this.$set(this.sendDataInfo.woApplyDetails[index], key, 0);
                        } else {
                            this.$set(this.sendDataInfo.woApplyDetails[index], key, item[key] != undefined && item[key] != null ? item[key] : "");
                        }
                    }
                    var setField = [];
                    if (this.setField) {
                        setField = this.setField.split(",");
                        setField.forEach((item1) => {
                            if (item1 == "psprice") {
                                this.$set(this.sendDataInfo.woApplyDetails[index], "psprice", item.psprice || 0);
                            } else {
                                this.$set(this.sendDataInfo.woApplyDetails[index], "psprice", item.psprice || 0);
                            }
                        });
                    } else {
                        this.$set(this.sendDataInfo.woApplyDetails[index], "psprice", item.psprice || 0);
                    }
                    this.calculatePrice(5, index)
                });
            }
            this.UDIshow = false
        },
        getValue(val, type, fieldType, arr) {
            var str = ""
            if (type == 'smIntype') {
                this.dictionariesDatas.forEach(item => {
                    if (item.diValue == val) {
                        str = item.diName
                    }
                })
            } else if (fieldType == 'formatter') {
                if (arr) {
                    JSON.parse(arr).forEach(item => {
                        if (String(Number(item.value)) != NaN && item.value == val) {
                            str = item.key
                        } else if (String(Number(item.key)) != NaN && item.key == val) {
                            str = item.value
                        }
                    })
                }
            } else {
                str = val || ""
            }
            return String(str)
        },
        clearChange(index, type) {
            if (type == 'bgmName') {
                this.sendDataInfo.woApplyDetails[index].bgmId = ""
            }
        },
        handleChange(value, name, num) {
            // value默认参，name当前所需的name
            this.sendDataInfo.woApplyDetails[num][name] = value;
            console.log(this.sendDataInfo.woApplyDetails[num][name]);
        },
        async blur(focusField, index, ownField, title) {
            setTimeout(async () => {
                //失去焦点事件和点击事件冲突addDetail
                if (title == "blur") {
                    this.blurData = title;
                } else {
                    this.blurData = "";
                }
                if (this.flags) {
                    this.flags = false;
                    return;
                }
                this.fField = focusField;
                this.seIndex = index;
                this.seType = ownField;
                let params = {
                    formId: this.formDataList[1].jciId,
                    num: "",
                    psprice: "",
                };
                if (ownField == "woadPnumber") {
                    params.num = this.sendDataInfo.woApplyDetails[index][ownField];
                } else if (ownField == "psprice") {
                    params.psprice =
                        this.sendDataInfo.woApplyDetails[index][ownField];
                }
                if (ownField) {
                    console.log("开始方法22");
                    await this.$http.interceptSuNumPsPrice(params).then((res) => {
                        this.flag = -1;
                        this.dialogList = []
                        if (res.result != null && res.result.length > 0) {
                            res.result.forEach(item => {
                                this.dialogList.push(item)
                            })
                            this.flag = this.dialogList.findIndex(
                                (item) => item.level == 0
                            );
                        } else {
                            console.log(
                                this.sendDataInfo.woApplyDetails[index][ownField]
                            );
                            if (
                                this.sendDataInfo.woApplyDetails[index][ownField] != 0
                            ) {
                                this.tableNextFocus(this.fField, this.seIndex);
                            }
                        }
                        console.log(this.flag);
                        if (this.flag == 0) this.showDialog1 = true;
                        if (this.flag != -1) {
                            this.$nextTick(() => {
                                if (title != "blur") {
                                    this.flags = true;
                                }
                                this.sendDataInfo.woApplyDetails[index][ownField] = 0;
                                this.$refs[ownField][index].blur();
                            });
                        }
                    });
                }
            }, 150);
        },
        intercept() {
            this.showDialog1 = false;

            if (this.flag == -1) {
                this.tableNextFocus(this.fField, this.seIndex);
            } else {
                this.$nextTick(() => {
                    this.$refs[this.seType][this.seIndex].focus();
                });
            }
        },
        tabHeight(val) {
            this.mxHeight = val;
        },
        Historical(url, title) {
            this.currentComponent = url;
            if (this.currentComponent == "historicalSalesOrder") {
                this.historicalOrder.cmName = this.sendDataInfo["cmName"];
                this.historicalOrder.cmId = this.sendDataInfo["cmId"];
            }
            if (this.sendDataInfo["woApplyDetails"].length > 0) {
                this.historicalOrder.bgmId =
                    this.sendDataInfo["woApplyDetails"][
                        this.selectedDetailsIndex
                    ].bgmId;
                this.historicalOrder.bgmName =
                    this.sendDataInfo["woApplyDetails"][
                        this.selectedDetailsIndex
                    ].bgmName;
            }
            this.$nextTick(() => {
                this.$refs[this.currentComponent].openBox(
                    this.historicalOrder,
                    title
                );
            });
        },
        changeTime(val) {
            if (val) {
                var time = val + 24 * 60 * 60 * 1000 - 1;
                this.priceApplicationData.wosaEnddate = time;
                console.log(this.priceApplicationData.wosaEnddate);
            }
        },
        //触发提取
        openExtSearch(id, type) {
            this.actionButtonId = id
            this.interceptFlag = false
            if (type == 'conmId') {
                this.ppId = type
            } else {
                this.ppId = 'orderId'
            }
            if (id == '5214106197263729') {
                this.ppId = 'psbkmId'
                this.cmId = this.sendDataInfo.cmId;
            }
            if (id == '1721092115898') {
                this.interceptFlag = true
            }
            this.exId = id;
            this.DialogExtract = true;
        },
        //提取返回
        async getDataByChen(val) {
            console.log(val);
            if (val != "" || val != undefined) {
                if (this.actionButtonId !== '5214106197263729' && this.sendDataInfo.cmId && this.sendDataInfo.cmId !== val.cmId)
                    return this.$message({
                        message: "请提取相同销售单位的单据",
                        type: "error",
                    });
                for (let key in val) {
                    if (key == "arrlistbychen") {
                        if (this.ppId == 'conmId') {
                            let arr = []
                            val.arrlistbychen.forEach(item => {
                                arr.push(
                                    {
                                        "bgmId": item.bgmId,
                                        "coId": val.coId,
                                        "condId": item.condId,
                                        "cmId": val.cmId,
                                        "ftNum": item.num
                                    }
                                )
                            })
                            this.$http.sucontractQueryFtDetail(arr).then(res => {
                                if (res.status == 200) {
                                    this.sendDataInfo.woApplyDetails = res.result
                                    this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                                        this.sendDataInfo.totalMoney += item.rrdPsmoney;
                                        this.sendDataInfo.totalNumber += item.oldNum;
                                        this.calculatePrice(5, index)
                                    });
                                    this.sendDataInfo.totalCount = this.sendDataInfo.woApplyDetails.length;
                                    this.$nextTick(() => {
                                        this.selectedDetailsIndex = 0;
                                        let refsElTable = this.$refs.mxTableRef;
                                        refsElTable.clearSelection();
                                        refsElTable.toggleRowSelection(
                                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                                        );
                                        this.nextFocus(0);
                                    });
                                } else {
                                    this.$message.error(res.message)
                                }
                            })
                        } else {
                            this.sendDataInfo.woApplyDetails = val.arrlistbychen;
                            this.sendDataInfo.woApplyDetails.forEach(item => {
                                if ((item.woadPnumber == 0 || item.woadPnumber === null || item.woadPnumber === undefined) && item.saleableNum !== undefined) {
                                    item.woadPnumber = item.saleableNum;
                                }
                            });
                        }
                    } else {
                        if (this.actionButtonId !== '5214106197263729') {
                            if (
                                (key == "depName" && val[key] == null) ||
                                (key == "opmName" && val[key] == null) ||
                                (key == "depId" && val[key] == null) ||
                                (key == "opmId" && val[key] == null)
                            ) {
                                this.sendDataInfo[key] = this.sendDataInfo[key];
                            } else {
                                this.sendDataInfo[key] = val[key];
                            }
                            if (
                                this.sendDataInfo[key] == null ||
                                this.sendDataInfo[key] == "null"
                            )
                                this.sendDataInfo[key] = "";
                            this.sendDataInfo.totalMoney = 0;
                            this.sendDataInfo.totalNumber = 0;
                            this.sendDataInfo.totalCount = 0;
                        }
                    }
                }
                if (!val.salesName || !val.salesId || !val.recName || !val.recId) {
                    this.$http.queryDefaultSales({
                        ids: [val.cmId]
                    }).then((res) => {
                        if (res && res.status == 200) {
                            for (const key in res.result) {
                                if (!this.sendDataInfo[key]) {
                                    this.sendDataInfo[key] = res.result[key];
                                }
                            }
                        }
                    })
                }
                this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                    this.sendDataInfo.totalMoney += item.rrdPsmoney;
                    this.sendDataInfo.totalNumber += item.oldNum;
                    this.calculatePrice(5, index)
                });
                if (val.psbkmId) {
                    this.sendDataInfo.psbkmId = val.psbkmId
                }
                this.sendDataInfo.totalCount =
                    this.sendDataInfo.woApplyDetails.length;
                this.DialogExtract = false;
                this.$nextTick(() => {
                    this.selectedDetailsIndex = 0;
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    );
                    this.nextFocus(0);
                });
            }
            this.parentSearchData.stId = this.sendDataInfo.stId;
            this.parentSearchData.cmId = this.sendDataInfo.cmId;
            this.parentSearchData.coId = this.sendDataInfo.coId;
        },
        getWidth(e) {
            this.exWidth = e + "%";
        },
        getExtractName(e) {
            this.exTitle = e;
        },
        // 获取主表单所有input
        getMainInput() {
            setTimeout(() => {
                var el = document.getElementById("mainInfo");
                if (el) this.inputel = el.getElementsByTagName("input");
            }, 100)
        },

        // 主表单select框切换enter切换焦点事件方法
        selectChange(e) {
            if (e == false) {
                for (let index = 0; index < this.inputel.length; index++) {
                    if (this.inputel[index] == document.activeElement) {
                        this.nextFocus(index);
                        break;
                    }
                }
            }
        },

        // 输入框切换焦点
        nextFocus(index, fField) {
            if (fField == "keydown") {
                var flag = false;
                if (this.sendDataInfo.woApplyDetails.length > 0) {
                    this.sendDataInfo.woApplyDetails.forEach((item) => {
                        if (item.bgmId == "") {
                            flag = true;
                        }
                    });
                }
                if (flag) {
                    return;
                }
                this.addDetail("sendDataInfo");
                return;
            }
            var aindex = index + 1;
            if (
                this.inputel[aindex].value != "" ||
                this.inputel[aindex].disabled
            ) {
                this.nextFocus(aindex);
                return;
            }
            this.inputel[aindex].focus();
        },

        // 初始化焦点
        initFocus() {
            for (let index = 0; index < this.inputel.length; index++) {
                if (this.inputel[index].value == "") {
                    this.inputel[index].focus();
                    break;
                }
            }
        },
        closeChild() {
            addEventListener("keyup", this.keyUp); //创建监听键盘事件
        },
        // 表格切换焦点方法
        tableNextFocus(field, index) {
            this.seIndex = index;
            if (field == "keydown") {
                this.addDetail("sendDataInfo");
                if (this.sendDataInfo.woApplyDetails[index + 1] != undefined) {
                    this.$refs["bgmName"][index + 1].focus();
                    this.selectedDetailsIndex = index + 1;
                    this.$nextTick(() => {
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                        );
                    });
                    return;
                }
                return;
            }
            this.$refs[field][index].focus();
        },

        // 监听键盘事件
        keyUp(e) {
            if (e.key == "F1") {
                // 右键新增明细
                e.preventDefault();
                this.addDetail("sendDataInfo");
                return;
            } else if (e.key == "F2") {
                e.preventDefault();
                this.deleteDetails();
            } else if (e.key == "F4" && this.dataActionBox.actionType != 2) {//保存
                this.sendDataAction('sendDataInfo')
            } else if (e.keyCode == 40) {
                // 下键
                // 表格为空，不执行下方
                if (this.sendDataInfo.woApplyDetails.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 如果当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (
                        this.selectedDetailsIndex ==
                        this.sendDataInfo.woApplyDetails.length - 1
                    ) {
                        // 如果选中的是最后一行了，那么下一行选中的是第一行
                        this.selectedDetailsIndex = 0;
                    } else {
                        // 正常递增
                        this.selectedDetailsIndex++;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            } else if (e.keyCode == 38) {
                // 上键
                if (this.sendDataInfo.woApplyDetails.length == 0) return;
                let refsElTable = this.$refs.mxTableRef;
                this.$nextTick(() => {
                    if (this.selectedRow.length == 0) {
                        // 当前没有选中行，则直接选中第一个
                        this.selectedDetailsIndex = 0;
                    } else if (this.selectedDetailsIndex == 0) {
                        // 如果选中的是第一行了，那么下一行选中的是最后一行
                        this.selectedDetailsIndex =
                            this.sendDataInfo.woApplyDetails.length - 1;
                    } else {
                        // 正常递减
                        this.selectedDetailsIndex--;
                    }
                    if (!refsElTable) return;
                    let findRow = this.selectedRow.find(
                        (c) => c.rowIndex == this.selectedDetailsIndex
                    ); //找出当前选中行
                    //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
                    if (findRow && this.selectedRow.length === 1) {
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[
                            this.selectedDetailsIndex
                            ],
                            false
                        );
                        return;
                    }
                    // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    ); // 把现在当前行勾选
                });
            }
        },

        // 表格方法
        rowClassName({ row, rowIndex }) {
            let rowName = "",
                findRow = this.selectedRow.find((c) => c.rowIndex === row.rowIndex);
            if (findRow) {
                rowName = "rowStyle "; // 可以通过此处给选中行一个class，根据自己需求更改样式
            }
            return rowName; //也可以再加上其他类名 如果有需求的话
        },

        // 选中行底色逻辑
        rowStyle({ row, rowIndex }) {
            Object.defineProperty(row, "rowIndex", {
                // 给每行添加不可枚举属性rowIndex来标识当前行
                value: rowIndex,
                writable: true,
                enumerable: false,
            });
            let rowBackground = {};
            if (row.bgColor && row.bgColor != "")
                rowBackground.backgroundColor = row.bgColor;
            return rowBackground;
        },

        // 明细表格点击选中
        clickEvent(row, column, event, params) {
            let refsElTable = this.$refs.mxTableRef; // 获取表格对象
            let findRow = {};
            this.selectedDetailsIndex = row.rowIndex;
            findRow = this.selectedRow.find((c) => c.rowIndex == row.rowIndex); //找出当前选中行
            //如果只有一行且点击的也是这一行则取消选择 否则清空再选中当前点击行
            if (findRow && this.selectedRow.length === 1) {
                refsElTable.toggleRowSelection(row, false);
                return;
            }
            // this.tableNextFocus('bgmName',this.selectedDetailsIndex)
            refsElTable.clearSelection();
            refsElTable.toggleRowSelection(row);
        },

        // 保存已选择行
        handleSelectionChange(rows) {
            this.selectedRow = rows; // 保存已选择行
        },

        // 查看证照
        lookLicence() {
            if (this.sendDataInfo.cmId == "") {
                return this.$message({
                    message: "请先选择销售单位",
                    type: "warning",
                });
            }
            this.$parent.$parent.toDetail(this.sendDataInfo.cmId);
        },

        // 打开维护地址
        openAddress() {
            if (this.sendDataInfo.cmId == "") {
                return this.$message({
                    message: "请先选择销售单位",
                    type: "warning",
                });
            }
            this.$refs["customerAddress"].openBox(
                0,
                this.sendDataInfo.cmId,
                "",
                "sales"
            );
        },

        // 子组件穿透方法
        toDetail(orderId) {
            if (this.dataActionBox.actionType != 2)
                this.$parent.$parent.toDetail(orderId);
            else this.$parent.$parent.$parent.toDetail(orderId);
        },

        //换行提示
        lineMessageBox(data) {
            let txtArr = data.message.split("<br/>");
            let newArr = [];
            const h = this.$createElement;
            for (const i in txtArr) {
                newArr.push(h("p", null, txtArr[i]));
            }
            this.$alert(h("div", null, newArr), "提示", {
                confirmButtonText: "确定",
                callback: (action) => { },
            });
        },

        // 检索Id, 索引(表格中), 标识
        //        检索Id, 索引， 字段名，赋值字段，焦点字段, 不可赋值字段
        openSearch(sId, index, type, sField, fField, nosField, setField) {
            setTimeout(() => {
                this.showDialog = false;
            }, 16.7);
            if (type == "salesName" || type == "caiAddress" || type == "recName") {
                if (this.sendDataInfo.cmId == "") {
                    return this.$message({
                        message: "请先选择销售单位",
                        type: "warning",
                    });
                }
            }
            this.DialogVisible = true;
            removeEventListener("keyup", this.keyUp);
            this.seId = sId;
            this.seIndex = index;
            this.seType = type;
            this.sField = sField;
            this.fField = fField;
            this.nosField = nosField;
            this.isRepetition = false
            if (setField) {
                this.setField = setField
            } else {
                this.setField = ""
            }
            if (type == "bgmName") {
                this.isRepetition = true
                this.isRepetitionList = this.sendDataInfo.woApplyDetails

                for (let key in this.sendDataInfo) {
                    this.parentSearchData[key] = this.sendDataInfo[key];
                }
                this.parentSearchData.bgmName =
                    this.sendDataInfo.woApplyDetails[this.seIndex].bgmName;
                if (this.parentSearchData.bgmName) {
                    let fh = 0;
                    if (this.parentSearchData.bgmName.indexOf(",") != -1) {
                        fh = ",";
                    } else if (this.parentSearchData.bgmName.indexOf("，") != -1) {
                        fh = "，";
                    }
                    if (fh !== 0) {
                        const str = this.parentSearchData.bgmName;
                        const list = str.split(fh);
                        this.parentSearchData.bgmName = list[0] || "";
                        this.parentSearchData.manufacturer = list[1] || "";
                    } else {
                        this.parentSearchData.manufacturer = "";
                    }
                } else {
                    this.parentSearchData.bgmName = "";
                    this.parentSearchData.manufacturer = "";
                }
                this.selectedDetailsIndex = this.seIndex;
                let refsElTable = this.$refs.mxTableRef;
                refsElTable.clearSelection();
                refsElTable.toggleRowSelection(
                    this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                );
                return;
            }
            for (const key in this.sendDataInfo) {
                if (this.sendDataInfo[key] != null && this.sendDataInfo[key] !== "") {
                    this.parentSearchData[key] = this.sendDataInfo[key];
                } else {
                    this.parentSearchData[key] = ""
                }
            }
        },

        // 不可赋值字段
        noSetField(val) {
            let arr = this.nosField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },

        // 赋值字段
        paramValue(val) {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                if (
                    (item == "depName" && (val[item] == null || val[item] == "" || val[item] == 0)) ||
                    (item == "opmName" && (val[item] == null || val[item] == "" || val[item] == 0)) ||
                    (item == "depId" && (val[item] == null || val[item] == "" || val[item] == 0)) ||
                    (item == "opmId" && (val[item] == null || val[item] == "" || val[item] == 0))
                ) {
                    this.sendDataInfo[item] = this.sendDataInfo[item];
                } else {
                    this.sendDataInfo[item] = val[item];
                }
            });
            this.$nextTick(() => {
                this.nextFocus(this.seIndex);
            });
        },

        // 清除赋值字段数据
        clearValue() {
            let arr = this.sField.split(",");
            arr.forEach((item) => {
                this.sendDataInfo[item] = "";
            });
        },
        verifyPustate(val) {
            if (val.cmSustate == 0) {
                this.$set(this, 'cmSustate', val.cmSustate)
                this.$set(this, 'cmSustateRemark', `该客户已停用，${val.cmSustateRemark}`)
                this.$set(this, 'showCmSustateDialog', true)
                return false
            }
            return true
        },
        //检索带回数据,
        changeInputModel(val) {
            // debuggger
            console.log(val);
            if (val != "" || val != undefined) {
                this.DialogVisible = false;
                addEventListener("keyup", this.keyUp); //创建监听键盘事件
                if (this.seType == "cmName") {
                    if (!this.verifyPustate(val)) return
                    //销售单位
                    this.$http.checkCustomerSale({
                        //校验单位
                        formId: this.formDataList[0].jciId, //表单ID
                        unitId: val.cmId, //单位ID
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            let flag = -1;
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => { this.dialogList.push(item) })
                                flag = this.dialogList.findIndex(item => item.level == 0);
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.parentSearchData.cmId = val.cmId;
                                this.sendDataInfo.cmId = val.cmId;
                                this.sendDataInfo.cmName = val.cmName;
                                this.$http.queryDefaultSales({
                                    ids: [val.cmId]
                                }).then((res) => {
                                    if (res && res.status == 200) {
                                        var valObj = {
                                            ...val,
                                            ...res.result,
                                        }
                                        if (valObj.salesName && valObj.salesId && this.sField.indexOf('salesName') != -1 && this.sField.indexOf('salesId') != -1) {
                                            //对方业务员
                                            this.$http.checkSalesSale({
                                                //校验对方业务员
                                                formId: this.formDataList[0].jciId, //表单ID
                                                salesId: valObj.salesId, //业务员ID
                                            }).then((res) => {
                                                if (res && res.status == 200) {
                                                    let flag = -1;
                                                    if (res.result != null && res.result.length > 0) {
                                                        res.result.forEach(item => {
                                                            this.dialogList.push(item)
                                                        })
                                                        flag = this.dialogList.findIndex((item) => item.level == 0);
                                                        this.showDialog = true;
                                                    }
                                                    if (flag == -1) {
                                                        this.sendDataInfo.salesName = valObj.salesName;
                                                        this.sendDataInfo.salesId = valObj.salesId;
                                                        if (valObj.recName && valObj.recId && this.sField.indexOf('recName') != -1 && this.sField.indexOf('recId') != -1) {
                                                            //收货员
                                                            this.$http.checkRecSalesSale({
                                                                //校验收货员
                                                                formId: this.formDataList[0].jciId, //表单ID
                                                                salesId: valObj.recId, //业务员ID
                                                            }).then((res) => {
                                                                if (res && res.status == 200) {
                                                                    let salesFlag = -1;
                                                                    if (res.result != null && res.result.length > 0) {
                                                                        res.result.forEach(item => {
                                                                            this.dialogList.push(item)
                                                                        })
                                                                        salesFlag = this.dialogList.findIndex((item) => item.level == 0);
                                                                        this.showDialog = true;
                                                                    }
                                                                    if (salesFlag == -1) {
                                                                        this.paramValue(valObj);
                                                                    }
                                                                } else {
                                                                    this.lineMessageBox(res);
                                                                    return false;
                                                                }
                                                            }).catch((rej) => {
                                                                this.lineMessageBox(rej);
                                                            });
                                                        } else {
                                                            this.paramValue(valObj);
                                                        }
                                                    } else {
                                                        this.showDialog = true;
                                                    }
                                                } else {
                                                    this.lineMessageBox(res);
                                                }
                                            }).catch((rej) => {
                                                this.lineMessageBox(rej);
                                            });
                                        } else {
                                            this.paramValue(valObj)
                                        }
                                    } else {
                                        this.paramValue(val)
                                    }
                                }).catch((rej) => {
                                    this.lineMessageBox(rej);
                                });
                            } else {
                                this.showDialog = true;
                            }
                            return true;
                        } else {
                            this.lineMessageBox(res);
                            this.parentSearchData.cmId = "";
                            this.clearValue();
                            return false;
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.parentSearchData.cmId = "";
                        this.clearValue();
                    });
                } else if (this.seType == "pickupName") {
                    //自提人
                    this.$http.fromruleCheckSuDismode({
                        //校验自提人
                        formId: this.formDataList[0].jciId, //表单ID
                        pickupId: val.pickupId, //自提人ID
                        dismode: this.sendDataInfo.dismode

                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            let flag = -1;
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                flag = this.dialogList.findIndex(item => item.level == 0);
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.paramValue(val);
                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.clearValue();
                            return false;
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.clearValue();
                    });
                } else if (this.seType == "salesName") {
                    //对方业务员
                    this.$http.checkSalesSale({
                        //校验对方业务员
                        formId: this.formDataList[0].jciId, //表单ID
                        salesId: val.salesId, //业务员ID
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            let flag = -1;
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => { this.dialogList.push(item) })
                                flag = this.dialogList.findIndex(item => item.level == 0);
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.paramValue(val);
                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.clearValue();
                            return false;
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.clearValue();
                    });
                } else if (this.seType == "coName") {
                    //货主
                    this.coId = val.coId;
                    this.sendDataInfo.ormId = this.ormId;
                    this.paramValue(val);
                } else if (this.seType == "bgmName") {
                    if (val.length > 0) {
                        this.bgmSelect(val);
                        return;
                    }
                    if (val.expidate == null || val.expidate == "" || val.expidate == undefined) {
                    } else {
                        if (val.expidate < this.$common.getNewDayTime()) {
                            this.tableNextFocus("bgmName", this.seIndex);
                            return this.$message({
                                message: "该品种已过期，不允许销售!",
                                type: "error",
                            });
                        }
                    }
                    val.costAmount = 0;
                    val.costMoney = 0;
                    //商品明细
                    let bgiTypeArr = [], bgiRateArr = [];
                    this.sendDataInfo.woApplyDetails.forEach((v, index) => {
                        if (v.bgiType && v.bgiType != null && v.bgiType != "null") {
                            console.log(typeof v.bgiType);
                            bgiTypeArr.push(v.bgiType);
                        }
                        if (this.seIndex != index) {
                            if (v.outRate && v.outRate != null && v.outRate != "null") {
                                bgiRateArr.push(v.outRate);
                            }
                        }
                    });
                    if (val.bgiType && val.bgiType != null && val.bgiType != "null") {
                        bgiTypeArr[this.seIndex] = val.bgiType;
                    }
                    if (val.outRate && val.outRate != null && val.outRate != "null") {
                        bgiRateArr.push(val.outRate)
                    }
                    this.$http.checkScopeSale({
                        //校验明细商品
                        formId: this.mxForm.jciId, //表单ID
                        unitId: this.sendDataInfo.cmId, //销售单位ID
                        bgmId: [val.bgmId], //商品id
                        bgsId: [val.bgsId],
                        ormId: this.ormId, //     组织ID
                        salesId: this.sendDataInfo.salesId, // 对方业务员ID
                        bgiTypes: bgiTypeArr, //	药品类型
                        taxs: bgiRateArr, //	税率
                        recId: this.sendDataInfo.recId, //收货人
                        hospitalId: this.sendDataInfo.hospitalId || "",
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            let flag = -1;
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => { this.dialogList.push(item) })
                                flag = this.dialogList.findIndex(item => item.level == 0);
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.$set(this.sendDataInfo.woApplyDetails, this.seIndex, JSON.parse(JSON.stringify(val)));
                                this.noSetField(JSON.parse(JSON.stringify(val)));
                                var setField = [];
                                if (this.setField) {
                                    setField = this.setField.split(",");
                                    setField.forEach((item1) => {
                                        if (item1 == "psprice") {
                                            this.$set(this.sendDataInfo.woApplyDetails[this.sendDataInfo.woApplyDetails.length - 1], "psprice", val.psprice);
                                        } else {
                                            this.$set(this.sendDataInfo.woApplyDetails[this.sendDataInfo.woApplyDetails.length - 1], "psprice", val.psprice || 0);
                                        }
                                    });
                                } else {
                                    this.$set(this.sendDataInfo.woApplyDetails[this.sendDataInfo.woApplyDetails.length - 1], "psprice", val.psprice || 0);
                                }
                                this.$nextTick(() => {
                                    this.$set(this.sendDataInfo.woApplyDetails[this.seIndex], "psmoney", 0);
                                    this.$set(this.sendDataInfo.woApplyDetails[this.seIndex], "money", 0);
                                    this.$set(this.sendDataInfo.woApplyDetails[this.seIndex], "woadPnumber", this.sendDataInfo.woApplyDetails[this.seIndex].woadPnumber || 0);
                                    this.tableNextFocus(this.fField, this.seIndex);
                                    this.selectedDetailsIndex = this.seIndex;
                                    let refsElTable = this.$refs.mxTableRef;
                                    refsElTable.clearSelection();
                                    refsElTable.toggleRowSelection(this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]);
                                });
                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.$set(this.sendDataInfo.woApplyDetails, this.seIndex, JSON.parse(JSON.stringify(this.detaislDataInfo)));
                            return false;
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.$set(this.sendDataInfo.woApplyDetails, this.seIndex, JSON.parse(JSON.stringify(this.detaislDataInfo)));
                        this.$set(this.sendDataInfo.woApplyDetails[this.seIndex], "woadPnumber", 0);
                    });
                } else if (this.seType == "recName") {
                    //收货员
                    this.$http.checkRecSalesSale({
                        //校验收货员
                        formId: this.formDataList[0].jciId, //表单ID
                        salesId: val.salesId, //业务员ID
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            let flag = -1;
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => { this.dialogList.push(item) })
                                flag = this.dialogList.findIndex(item => item.level == 0);
                                this.showDialog = true;
                            }
                            if (flag == -1) {
                                this.paramValue(val);
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.clearValue();
                            return false;
                        }
                    })
                        .catch((rej) => {
                            this.lineMessageBox(rej);
                            this.clearValue();
                        });
                } else if (this.seType == "ht") {
                    for (let key in val) {
                        this.sendDataInfo[key] = val[key];
                    }
                    this.parentSearchData.cmId = val.cmId;
                    this.sendDataInfo.woApplyDetails = [];
                } else if (this.seType == "companyName") {
                    this.showDialog = false;
                    let cmNameFlag = -1;
                    //销售单位
                    this.$http.checkLogicvality({
                        ids: [val.loId]
                    }).then((res) => {
                        this.dialogList = []
                        if (res && res.status == 200) {
                            if (res.result != null && res.result.length > 0) {
                                res.result.forEach(item => {
                                    this.dialogList.push(item)
                                })
                                cmNameFlag = this.dialogList.findIndex(
                                    (item) => item.level == 0
                                );
                                this.showDialog = true;
                            }
                            if (cmNameFlag == -1) {
                                if (this.setField) {
                                    const setField = this.setField.split(",");
                                    for (let i = 0; i < setField.length; i++) {
                                        const field = setField[i];
                                        this.sendDataInfo[field] = val[field];
                                    }
                                } else {
                                    this.sendDataInfo.companyName = val.companyName;
                                    this.sendDataInfo.loId = val.loId;
                                }
                            } else {
                                this.showDialog = true;
                            }
                        } else {
                            this.lineMessageBox(res);
                            this.clearValue();
                        }
                    }).catch((rej) => {
                        this.lineMessageBox(rej);
                        this.clearValue();
                    });
                } else {
                    this.paramValue(val);
                }
            }
        },
        //多选商品数据处理
        bgmSelect(val) {
            //商品明细
            let bgiTypeArr = [],
                bgiRateArr = [],
                bgmIds = [],
                bgsIds = [];
            var flag = false;
            this.sendDataInfo.woApplyDetails.forEach((v, index) => {
                if (
                    v.bgiType &&
                    v.bgiType != null &&
                    v.bgiType != "null" &&
                    v.bgmName != ""
                ) {
                    console.log(typeof v.bgiType);
                    bgiTypeArr.push(v.bgiType);
                }
                if (this.seIndex != index) {
                    if (v.outRate && v.outRate != null && v.outRate != "null" && v.bgmName != "") {
                        bgiRateArr.push(v.outRate);
                    }
                }
            });
            val.forEach((item) => {
                if (
                    item.expidate == null ||
                    item.expidate == "" ||
                    item.expidate == undefined
                ) {
                } else {
                    if (item.expidate < this.$common.getNewDayTime()) {
                        flag = true;
                    }
                }
                if (!item.costAmount) {
                    item.costAmount = 0;
                }
                if (!item.costMoney) {
                    item.costMoney = 0;
                }
                if (
                    item.outRate &&
                    item.outRate != null &&
                    item.outRate != "null" &&
                    item.bgmName != ""
                ) {
                    bgiRateArr.push(item.outRate);
                }
                bgiTypeArr.push(item.bgiType);
                bgmIds.push(item.bgmId);
                bgsIds.push(item.bgsId);
            });
            bgiTypeArr.forEach((item, i) => {
                if (item == null || item == "null") bgiTypeArr.splice(i, 1);
            });
            if (flag) {
                return this.$message({
                    message: "该品种已过期，不允许销售!",
                    type: "error",
                });
            }
            this.$http.checkScopeSale({
                //校验明细商品
                formId: this.mxForm.jciId, //表单ID
                unitId: this.sendDataInfo.cmId, //销售单位ID
                bgmId: bgmIds, //商品id
                bgsId: bgsIds,
                ormId: this.ormId, //     组织ID
                salesId: this.sendDataInfo.salesId, // 对方业务员ID
                bgiTypes: bgiTypeArr, //	药品类型
                taxs: bgiRateArr, //	税率
                recId: this.sendDataInfo.recId, //收货人
                hospitalId: this.sendDataInfo.hospitalId || "",
            }).then((res) => {
                this.dialogList = []
                if (res && res.status == 200) {
                    let flag = -1;
                    res.result.forEach(item => {
                        this.dialogList.push(item)
                    })
                    if (this.dialogList != null && this.dialogList.length > 0) {
                        flag = this.dialogList.findIndex(item => item.level == 0);
                        this.showDialog = true;
                    }
                    if (flag == -1) {
                        if (this.sendDataInfo.woApplyDetails && this.sendDataInfo.woApplyDetails.length > 0) {
                            var mx = JSON.parse(JSON.stringify(val));
                            mx.forEach(item => {
                                item.woadPnumber = item.woadPnumber || 0
                                item.psmoney = item.psmoney || 0
                                item.money = item.money || 0
                                item.isTicket = Number(this.ticket) || ""
                            })
                            this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                                if (item.bgmId == "" || item.bgmName == "") {
                                    this.sendDataInfo.woApplyDetails.splice(index, 1);
                                }
                            });
                            const numberList = this.mxForm.jurconfigform.filter((item) => item.fieldType == "number").map((item) => item.entityField);
                            mx.forEach((item) => {
                                this.sendDataInfo.woApplyDetails.push({});
                                for (const key in this.detaislDataInfo) {
                                    const index1 = numberList.findIndex(
                                        (items) => items == key
                                    );
                                    if (index1 != -1 && !item[key]) {
                                        this.$set(this.sendDataInfo.woApplyDetails[this.sendDataInfo.woApplyDetails.length - 1], key, 0);
                                    } else {
                                        this.$set(this.sendDataInfo.woApplyDetails[this.sendDataInfo.woApplyDetails.length - 1], key, item[key] != undefined && item[key] != null ? item[key] : "");
                                    }
                                }
                                var setField = [];
                                if (this.setField) {
                                    setField = this.setField.split(",");
                                    setField.forEach((item1) => {
                                        if (item1 == "psprice") {
                                            this.$set(this.sendDataInfo.woApplyDetails[this.sendDataInfo.woApplyDetails.length - 1], "psprice", item.psprice);
                                        } else {
                                            this.$set(this.sendDataInfo.woApplyDetails[this.sendDataInfo.woApplyDetails.length - 1], "psprice", item.psprice || 0);
                                        }
                                    });
                                } else {
                                    this.$set(this.sendDataInfo.woApplyDetails[this.sendDataInfo.woApplyDetails.length - 1], "psprice", item.psprice || 0);
                                }
                            });
                        } else {
                            this.sendDataInfo.woApplyDetails = [];
                            const numberList = this.mxForm.jurconfigform.filter((item) => item.fieldType == "number").map((item) => item.entityField);
                            val.forEach((item, index) => {
                                item.woadPnumber = item.woadPnumber || 0
                                item.psmoney = item.psmoney || 0
                                item.money = item.money || 0
                                item.isTicket = Number(this.ticket) || ""
                                this.sendDataInfo.woApplyDetails.push({});
                                for (const key in this.detaislDataInfo) {
                                    const index = numberList.findIndex(items => items == key);
                                    if (index != -1 && !val[key]) {
                                        this.$set(this.sendDataInfo.woApplyDetails[index], key, 0);
                                    } else {
                                        this.$set(this.sendDataInfo.woApplyDetails[index], key, item[key] != undefined && item[key] != null ? item[key] : "");
                                    }
                                }
                                var setField = [];
                                if (this.setField) {
                                    setField = this.setField.split(",");
                                    setField.forEach((item1) => {
                                        if (item1 == "psprice") {
                                            this.$set(this.sendDataInfo.woApplyDetails[index], "psprice", item.psprice);
                                        } else {
                                            this.$set(this.sendDataInfo.woApplyDetails[index], "psprice", item.psprice || 0);
                                        }
                                    });
                                } else {
                                    this.$set(this.sendDataInfo.woApplyDetails[index], "psprice", item.psprice || 0);
                                }
                            });
                        }
                    } else {
                        this.$set(this.sendDataInfo.woApplyDetails, this.seIndex, JSON.parse(JSON.stringify(this.detaislDataInfo)));
                        return false;
                    }
                } else {
                    this.lineMessageBox(res);
                }
            }).catch((rej) => {
                this.lineMessageBox(rej);
                this.$set(this.sendDataInfo.woApplyDetails, this.seIndex, JSON.parse(JSON.stringify(this.detaislDataInfo)));
            });
        },
        getSeWidth(e) {
            this.seWidth = e + "%";
        },
        getSearchName(e) {
            this.seTitle = e;
        },
        // 打印方法
        showPrintPlan() {
            // 调用全局方法 判断Websocket是否连接
            if (this.$printSocketApi.printExeMsg() != false) {
                // 选中的数据
                this.$refs.printPlan.openDia(
                    this.actionData.orderId,
                    this.actionData.printSouce,
                    this.actionData.printJurId
                );
            } else {
                return;
            }
        },
        //确认新增
        async sendDataAction(formName1) {
            let flag = false;
            this.$refs[formName1].validate((valid) => {
                if (valid) {
                } else {
                    this.$message({
                        message: "请完善主表单必填信息",
                        type: "error",
                    });
                    flag = true;
                    return false;
                }
            });
            if (flag) return false;
            if (this.sendDataInfo.woApplyDetails.length < 1) {
                this.$message({
                    message: "请添加明细",
                    type: "error",
                });
                return false;
            } else {
                this.sendDataInfo.woApplyDetails.forEach((item, index) => {
                    if (item.bgmId == "") {
                        this.sendDataInfo.woApplyDetails.splice(index, 1);
                    }
                });
            }
            for (let j = 0; j < this.sendDataInfo.woApplyDetails.length; j++) {
                const itemvs = this.sendDataInfo.woApplyDetails[j];
                if (
                    itemvs.bgmId == "" ||
                    itemvs.woadPnumber <= 0 ||
                    itemvs.woadPnumber > itemvs.num
                ) {
                    this.$message({
                        message: "请填写商品、合理的销售数量",
                        type: "error",
                    });
                    this.$set(itemvs, "woadPnumber", 0);
                    return false;
                }
            }
            for (let key in this.sendDataInfo) {
                if (key == "") delete this.sendDataInfo[key];
            }
            this.sendDataInfo.desuUdisuouts = this.UDIlist == "" || this.UDIlist == undefined || this.UDIlist == null ? [] : this.UDIlist

            const arr = this.sendDataInfo.woApplyDetails.map(item => {
                return {
                    bgmId: item.bgmId,
                    psPirce: item.psprice,
                }
            })
            this.sendDataInfo.totalCount = this.sendDataInfo.woApplyDetails.length
            const res = await this.$http.woApplypriceIntercept(arr)
            if (res.status == 200) {
                this.sub()
            } else if (res.status == 300) {
                this.$confirm("存在价格为零，是否继续保存？", "提示", {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }).then(() => {
                    this.sub()
                }).catch(() => { });
            } else {
                this.$message({
                    message: res.message,
                    type: "error",
                });
            }
        },
        async sub() {
            if (this.dataActionBox.actionType == 0) {
                if (this.pageType == "one") {
                    var responseData = await this.$http.addSalesOrder(
                        this.sendDataInfo
                    );
                } else {
                    var responseData = await this.$http.addSalesOrderMerge(
                        this.sendDataInfo
                    );
                }
            } else {
                if (this.pageType == "one") {
                    var responseData = await this.$http.setSalesOrder(
                        this.sendDataInfo
                    );
                } else {
                    var responseData = await this.$http.setSalesOrderMerge(
                        this.sendDataInfo
                    );
                }
            }

            if (responseData.status == 200) {
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
                this.$refs.operSelect.openBox(responseData.result);
            } else {
                let txtArr = responseData.message.split("<br/>");
                let newArr = [];
                const h = this.$createElement;
                for (const i in txtArr) {
                    newArr.push(h("p", null, txtArr[i]));
                }
                this.$message({
                    message: h("div", null, newArr),
                    type: "error",
                });
            }
        },
        drawerCancel() {
            this.$emit("drawerCancel", true);
        },
        conAdd() {
            this.init();
            this.dataActionBox.actionType = 0;
            this.filterMainField();
            this.checkIsBuyer();
        },
        //新增明细
        addDetail(sendDataInfo) {
            var flag = false;
            if (this.sendDataInfo.woApplyDetails.length > 0) {
                this.sendDataInfo.woApplyDetails.forEach((item) => {
                    if (item.bgmId == "") {
                        flag = true;
                        return this.$message({
                            message: "请不要重复新增空白行",
                            type: "warning",
                        });
                    }
                });
            }
            if (flag) {
                return;
            }
            if (!this.$refs[sendDataInfo]) {
                return
            }
            this.$refs[sendDataInfo].validate((valid) => {
                if (valid) {
                    this.sendDataInfo.woApplyDetails.push({});
                    var index = this.sendDataInfo.woApplyDetails.length - 1;
                    for (const key in this.detaislDataInfo) {
                        this.$set(
                            this.sendDataInfo.woApplyDetails[index],
                            key,
                            this.detaislDataInfo[key]
                        );
                    }
                    this.$nextTick(() => {
                        this.selectedDetailsIndex = Number(
                            this.sendDataInfo.woApplyDetails.length - 1
                        );
                        this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                        let refsElTable = this.$refs.mxTableRef;
                        refsElTable.clearSelection();
                        refsElTable.toggleRowSelection(
                            this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                        );
                    });
                } else {
                    return this.$message({
                        message: "请完善必填信息",
                        type: "warning",
                    });
                }
            });
        },
        // 打开特价申请
        openPriceApplicationBox(goodsIndex = "") {
            if (this.sendDataInfo.woApplyDetails.length >= 1) {
                if (goodsIndex == "") {
                    var dataInfo =
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex];
                } else {
                    var dataInfo = this.sendDataInfo.woApplyDetails[goodsIndex];
                }
                this.priceApplicationData.bgmId = dataInfo.bgmId;
                this.priceApplicationData.bgmName = dataInfo.bgmName;
                this.priceApplicationData.coId = this.sendDataInfo.coId;
                this.priceApplicationData.coName = this.sendDataInfo.coName;
                this.priceApplicationData.wosaSalecus = this.sendDataInfo.woamSalecus;
                this.priceApplicationData.cmId = this.sendDataInfo.cmId;
                this.priceApplicationData.cmName = this.sendDataInfo.cmName;
                this.priceApplicationData.wosaAppprice = "";
                this.priceApplicationData.wosaAppreason = "";
                this.priceApplicationData.batchno = dataInfo.batchno;
                this.priceApplicationData.expidate = dataInfo.expidate;
                this.priceApplicationData.wosaEnddate = "";
                this.priceApplicationData.wosaMinprice = "";
                this.priceApplicationData.prodate = dataInfo.prodate;
                this.priceApplicationBox = true;
            } else {
                this.$message({
                    message: "请先添加明细数据",
                    type: "error",
                });
            }
        },
        initTime() {
            // this.getRequestData.start = this.$common.getStartTime()
            this.priceApplicationData.wosaEnddate = this.$common.getEndTime();
        },
        // 新增特价申请
        async addSpecialPriceApply() {
            if (this.priceApplicationData.wosaAppprice == "") {
                this.$message({
                    message: "请填写申请售价",
                    type: "error",
                });
                return false;
            }

            if (this.priceApplicationData.wosaEnddate == "") {
                this.$message({
                    message: "请选择截止日期",
                    type: "error",
                });
                return false;
            }

            let responseData = await this.$http.addSpecialPriceApply(
                this.priceApplicationData
            );
            if (responseData.status == 200) {
                this.priceApplicationBox = false;
                this.initTime();
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 打开缺货登记
        openStockRegisterBox() {
            if (this.sendDataInfo.woApplyDetails.length >= 1) {
                var dataInfo =
                    this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex];
                console.log("缺货登记", dataInfo);
                this.stockRegisterData.bgmId = dataInfo.bgmId;
                this.stockRegisterData.bgmName = dataInfo.bgmName;
                this.stockRegisterData.cmId = this.sendDataInfo.cmId;
                this.stockRegisterData.cmName = this.sendDataInfo.cmName;
                this.stockRegisterBox = true;
            } else {
                this.$message({
                    message: "请先添加明细数据",
                    type: "error",
                });
            }
        },

        // 新增缺货登记
        async addShortageRegistration() {
            if (this.stockRegisterData.wolrRegnumber == "") {
                this.$message({
                    message: "请先填写登记数量",
                    type: "error",
                });
                return false;
            }

            let responseData = await this.$http.addShortageRegistration(
                this.stockRegisterData
            );
            if (responseData.status == 200) {
                this.stockRegisterBox = false;
                this.$message({
                    message: "操作成功",
                    type: "success",
                });
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 检测最低价
        async getGoodsSockPrice(goodsIndex) {
            var dataInfo = this.sendDataInfo.woApplyDetails[goodsIndex];
            if (!dataInfo.psprice) {
                return false;
            }

            var sendData = {
                bgmId: dataInfo.bgmId,
                batchno: dataInfo.batchno,
                wosaAppprice: dataInfo.psprice,
                expidate: dataInfo.expidate,
                prodate: dataInfo.prodate,
                wosaSalecus: this.sendDataInfo.woamSalecus,
            };

            let responseData = await this.$http.getGoodsSockPrice(sendData);
            if (responseData.status == 200) {
                console.log(responseData);
                // this.stockRegisterBox = false
                // this.$message({
                // 	message: '操作成功',
                // 	type: 'success'
                // });
            } else {
                this.openPriceApplicationBox(goodsIndex);
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        //含税价拦截
        doCheckPrice(cate, index, entityField, focusField) {
            var info = this.sendDataInfo.woApplyDetails[index];
            if (info.psprice == 0 || info.psprice == '' || info.psprice == null) {
                this.calculatePrice(cate, index);
                return
            }
            let pspriceObj = {
                coId: this.sendDataInfo.coId, //货主ID
                bgmId: info.bgmId, //商品ID
                psprice: info.psprice, //商品价格
                costPrice: info.woadWcost, //成本价
                cmId: this.sendDataInfo.cmId, //客户ID
            };
            this.$http.checkPrice(pspriceObj).then((res) => {
                console.log("psprice", res);
                if (res.status == 200) {
                    this.calculatePrice(cate, index);
                } else if (res.status == 300) {
                    this.$message({
                        message: res.message,
                        type: "warning",
                    });
                    this.sendDataInfo.woApplyDetails[index].psprice = info.psprice;
                } else {
                    this.$refs[entityField][index].focus();
                    this.$message({
                        message: res.message,
                        type: "error",
                    });
                    this.sendDataInfo.woApplyDetails[index].psprice = 0;
                    this.calculatePrice(cate, index);
                    if (this.sendDataInfo.woApplyDetails.filter(item => item.bgmId == "" || item.bgmName == "").length > 0) {
                        this.sendDataInfo.woApplyDetails.splice(this.sendDataInfo.woApplyDetails.length - 1, 1)
                    }
                }
            });
        },
        blurwoadPnumber(cate, index, entityField, focusField) {
            var info = this.sendDataInfo.woApplyDetails[index];
            if (info.woadPnumber <= 0) {
                this.sendDataInfo.woApplyDetails[index].woadPnumber = 0
            } else {
                this.sendDataInfo.woApplyDetails[index].woadPnumber = this.$common.getDecimalInfo(1, info.woadPnumber);
            }
            this.doCheckPrice(cate, index, entityField, focusField)
        },
        // 计算价格
        calculatePrice(cate = 1, index, flag) {
            var info = this.sendDataInfo.woApplyDetails[index];
            if (info.woadPnumber <= 0 || isNaN(info.woadPnumber)) {
                if (!flag) {
                    this.$message({
                        message: "请先填写合理的销售数量",
                        type: "error",
                    });
                }
                this.$set(info, "woadPnumber", 0);
                this.$set(info, "money", 0);
                this.$set(info, "psmoney", 0);
                this.$set(info, "gross", 0); //毛利
                this.$set(info, "costMoney", 0); //含税成本金额
                this.$set(info, "costAmount", 0); //成本金额
                if (!flag) {
                    this.calculatePrice(cate, index, true)
                }
                return false;
            }

            // 缓存常用变量，避免重复访问
            const details = this.sendDataInfo.woApplyDetails[index];
            const quantity = info.woadPnumber;
            const taxRate = parseFloat(info.outRate) || 0; // 确保是数字类型
            const price = parseFloat(info.price) || 0;
            const psprice = parseFloat(info.psprice) || 0;
            const psmoney = parseFloat(info.psmoney) || 0;
            const costMoney = parseFloat(info.woadWcost) || 0;
            const costAmount = parseFloat(info.costPrice) || 0;

            // 创建税率计算辅助函数
            const calculateTaxFactor = () => NP.plus(1, NP.divide(taxRate, 100));
            const calculateTaxAdjustedPrice = (basePrice) => this.$common.getDecimalInfo(2, NP.times(basePrice, calculateTaxFactor()));
            const calculateBaseFromTaxed = (taxedValue) => this.$common.getDecimalInfo(3, NP.divide(taxedValue, calculateTaxFactor()));

            // 根据不同计算类型更新明细数据
            switch (cate) {
                case 1: // 通过单价计算全部
                    // 计算含税价格 单价+单价*税率/100
                    details.psprice = calculateTaxAdjustedPrice(price);
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(details.psprice, quantity)); // 计算含税金额 含税价格*数量
                    details.money = calculateBaseFromTaxed(details.psmoney); // 计算总金额 含税金额/(税率/100+1)
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money)); // 计算税额
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    break;

                case 2: // 通过含税价格计算全部
                    details.psmoney = quantity === 0 ? 0 : this.$common.getDecimalInfo(3, NP.times(psprice, quantity)); // 计算含税金额 含税价格*数量
                    details.money = calculateBaseFromTaxed(details.psmoney); // 计算金额 含税金额/(税率/100+1)
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.money, quantity)); // 计算单价 金额/数量
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money)); // 计算税额
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    break;

                case 3: // 通过金额计算全部
                    details.price = quantity ? this.$common.getDecimalInfo(2, NP.divide(info.money, quantity)) : 0; // 计算单价  金额 / 数量
                    details.psprice = calculateTaxAdjustedPrice(details.price); // 计算含税价格
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(details.psprice, quantity)); // 计算含税金额 含税价格*数量
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, info.money)); // 计算税额
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    break;

                case 4: // 通过含税金额计算全部
                    details.psmoney = psmoney;
                    details.money = calculateBaseFromTaxed(psmoney); // 计算总金额 含税金额/(税率/100+1)
                    details.psprice = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(psmoney, quantity)); // 计算含税价格  含税金额 / 数量
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.money, quantity)); // 计算单价 金额/数量
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(psmoney, details.money)); // 计算税额
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((details.psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    break;

                case 8://通过含税原价
                    details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), (quantity || 0)));
                    details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                    details.orPrice = info.woadPnumber === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.orMoney, quantity));
                    details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
                    break;

                case 9://通过不含税原价
                    // 计算含税原价格 不含税原价+不含税原价*税率/100
                    details.orPsprice = calculateTaxAdjustedPrice(info.orPrice);
                    details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((details.orPsprice || 0), (quantity || 0)));
                    details.orMoney = this.$common.getDecimalInfo(3, NP.times((info.orPrice || 0), (quantity || 0)));
                    details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (details.orPsprice || 0)), 100));
                    break;

                default: // 通过数量计算
                    details.psmoney = this.$common.getDecimalInfo(3, NP.times(psprice, quantity)); // 计算含税金额 含税价格*数量
                    details.money = calculateBaseFromTaxed(details.psmoney); // 计算总金额 含税金额/(税率/100+1)
                    details.price = quantity === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.money, quantity)); // 计算单价 金额/数量
                    details.wholeNum = Math.floor(NP.divide(quantity, Number(info.packingSpec))); // 计算整件数量
                    details.scatNum = NP.minus(quantity, NP.times(details.wholeNum, Number(info.packingSpec))); // 计算零散数量
                    details.taxAmount = this.$common.getDecimalInfo(3, NP.minus(details.psmoney, details.money)); // 计算税额
                    details.costMoney = this.$common.getDecimalInfo(3, NP.times(costMoney, quantity)); // 含税成本金额 = 含税成本 * 数量
                    details.costAmount = this.$common.getDecimalInfo(3, NP.times(costAmount, quantity)); // 成本金额 = 库存成本 * 数量
                    if (info.orPsprice != null && info.orPsprice != undefined) {
                        details.orPsmoney = this.$common.getDecimalInfo(3, NP.times((info.orPsprice || 0), (quantity || 0)));
                        details.orMoney = calculateBaseFromTaxed(details.orPsmoney);
                        details.orPrice = info.woadPnumber === 0 ? 0 : this.$common.getDecimalInfo(2, NP.divide(details.orMoney, quantity));
                        details.disRate = this.$common.getDecimalInfo(2, NP.times(NP.divide((psprice || 0), (info.orPsprice || 0)), 100));
                    }
                    // 计算件数 采数/包装单位
                    if (parseFloat(info.packingSpec) <= 0 || !info.packingSpec) {
                        details.pieceNum = 0;
                    } else {
                        details.pieceNum = this.$common.getDecimalInfo(1, NP.divide(quantity, info.packingSpec));
                    }
                    break;
            }

            // 计算折扣价格
            details.disPrice = this.$common.getDecimalInfo(2, NP.minus(info.disPreprice || 0, info.psprice || 0));

            // 计算毛利相关信息
            const moneyAfterTax = parseFloat(details.psmoney) || 0;
            const costMoneyAfterTax = parseFloat(details.costMoney) || 0;
            details.gross = this.$common.getDecimalInfo(3, NP.minus(moneyAfterTax, costMoneyAfterTax)); // 毛利 = 销售金额 - 成本金额
            details.taxgross = this.$common.getDecimalInfo(3, NP.minus(parseFloat(details.money) || 0, parseFloat(details.costAmount) || 0)); // 不含税毛利 = 金额 - 成本金额

            // 计算毛利率
            if (details.gross === 0 || moneyAfterTax === 0) {
                details.grossProfit = 0;
            } else {
                details.grossProfit = this.$common.getDecimalInfo(2, NP.divide(details.gross, moneyAfterTax));
            }

            // 重新计算所有总计数据，而不是只基于当前项
            this.updateTotalStats();
        },

        // 新增一个方法来计算总的统计数据
        updateTotalStats() {
            let totalMoney = 0;
            let totalNumber = 0;
            let totalCount = this.sendDataInfo.woApplyDetails.length;

            // 单次遍历计算所有总计值
            for (let i = 0; i < this.sendDataInfo.woApplyDetails.length; i++) {
                const detail = this.sendDataInfo.woApplyDetails[i];
                totalMoney += parseFloat(detail.psmoney) || 0;
                totalNumber += parseFloat(detail.woadPnumber) || 0;
            }

            this.sendDataInfo.totalMoney = this.$common.getDecimalInfo(3, totalMoney);
            this.sendDataInfo.totalNumber = this.$common.getDecimalInfo(3, totalNumber);
            this.sendDataInfo.totalCount = totalCount;
        },

        //取消
        initActionBox(formName1, formName2) {
            this.$confirm(
                "确定取消" + this.dataActionBox.boxTitle + "吗?",
                "提示",
                {
                    confirmButtonText: "确定",
                    cancelButtonText: "取消",
                    type: "warning",
                }
            )
                .then(() => {
                    this.$emit("drawerCancel");
                    this.init();
                    this.$refs[formName1].resetFields();
                    this.$refs[formName2].resetFields();
                })
                .catch(() => { });
        },

        //初始化
        init() {
            for (let key in this.sendDataInfo) {
                if (key == "woApplyDetails") {
                    this.sendDataInfo[key] = [];
                } else {
                    this.sendDataInfo[key] = "";
                }
            }
            this.sendDataInfo.woamSaledate = this.$moment().valueOf();

            this.sendDataInfo.woApplyDetails = [];
            this.sendDataInfo.totalCount = 0;
            this.sendDataInfo.totalMoney = 0;
            this.sendDataInfo.totalNumber = 0;
            this.sendDataInfo.orderType = 1; //orderType	订单类型0.药品订单1.器械订单
        },

        // 选择业务员
        selectUserOne(data) {
            data.forEach((item) => {
                if (item.opmId == this.sendDataInfo.woamSalesman) {
                    this.sendDataInfo.depId = item.depId; //   业务部门
                    this.sendDataInfo.depName = item.depName; //   业务部门
                }
            });
        },
        async isShowData(name, value) {
            switch (name) {
                case "woamSalecus":
                    var dataInfo = sessionStorage.getItem("selectCustomerData");
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.woamSalecus = dataInfo.cmId;
                        this.sendDataInfo.woamSalecusName = dataInfo.cmName;
                    }
                    this.sendDataInfo.woamOpposalesman = "";
                    this.getUnitSalesmanList();
                    break;
                case "cargoOwner":
                    var dataInfo = sessionStorage.getItem("selectCargoOwnerData");
                    // console.log(dataInfo)
                    if (dataInfo) {
                        dataInfo = JSON.parse(dataInfo);
                        this.sendDataInfo.coId = dataInfo.coId;
                        this.sendDataInfo.coName = dataInfo.coName;
                    }
                    break;
                default:
                    this.sendDataInfo[name] = value;
            }
        },

        //上级流入
        openBox() {
            this.pageType = this.actionData.type;
            this.dataActionBox.actionType = this.actionData.cate;
            this.formDataList = this.actionData.formData;
            this.filterMainField();
            var oldData = this.actionData.oldData;
            this.showTabs = this.actionData.formData[0].jciName;
            if (this.dataActionBox.actionType == 0) {
                this.dataActionBox.boxTitle = "新增信息";
                this.dataActionBox.openMode = "ltr";
                this.checkIsBuyer();
            } else if (this.dataActionBox.actionType == 1) {
                this.cmId = oldData.cmId;
                this.ormId = oldData.ormId
                    ? oldData.ormId
                    : JSON.parse(sessionStorage.getItem("loginInfo")).ormId;
                this.coId = oldData.coId;
                this.dataActionBox.boxTitle = "编辑信息";
                this.dataActionBox.openMode = "rtl";
                for (const key in oldData) {
                    this.$set(this.sendDataInfo, key, oldData[key]);
                }
                this.$set(this.sendDataInfo, "orderType", 1); //orderType	订单类型0.药品订单1.器械订单
                this.getUnitSalesmanList();
                this.UDIlist = oldData.desuUdisuouts
            } else {
                this.dataActionBox.boxTitle = "查看信息";
                var dataInfo = JSON.parse(JSON.stringify(oldData));
                console.log(dataInfo, "look");
                for (const key in dataInfo) {
                    this.$set(this.sendDataInfo, key, dataInfo[key]);
                }
                this.$set(this.sendDataInfo, "orderType", 1); //orderType	订单类型0.药品订单1.器械订单
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    if (this.dataActionBox.actionType != 2) {
                        this.mxHeight = this.$common.getBtnHeight();
                    } else {
                        this.mxHeight = this.$common.getHeight();
                    }
                    this.initFocus();
                }, 16.7);
            });
        },
        // 默认值
        initDefaultValue() {
            let arr = this.formDataList[0].jurconfigform;
            arr.forEach((item) => {
                if (
                    item.defaultValue != "null" &&
                    item.defaultValue != null &&
                    item.defaultValue != ""
                ) {
                    this.sendDataInfo[item.entityField] = item.defaultValue;
                }
            });
            this.sendDataInfo.isWms = Number(this.sendDataInfo.isWms);
            this.sendDataInfo.woamSaledate = this.$moment().valueOf();
        },

        //删除明细
        deleteDetails() {
            this.sendDataInfo.woApplyDetails.splice(this.selectedDetailsIndex, 1);
            this.$nextTick(() => {
                if (this.sendDataInfo.woApplyDetails.length > 1) {
                    this.selectedDetailsIndex = Number(
                        this.selectedDetailsIndex - 1
                    );
                    this.tableNextFocus("bgmName", this.selectedDetailsIndex);
                    let refsElTable = this.$refs.mxTableRef;
                    refsElTable.clearSelection();
                    refsElTable.toggleRowSelection(
                        this.sendDataInfo.woApplyDetails[this.selectedDetailsIndex]
                    );
                } else {
                    this.selectedDetailsIndex = 0;
                }
            });
        },

        // 获取业务员
        async getUnitSalesmanList() {
            this.salesmanList = [];
            let responseData = await this.$http.getUnitSalesmanList({
                ids: [this.sendDataInfo.cmId],
            });
            if (responseData.status == 200) {
                this.salesmanList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取业务员
        async getSpecialUser() {
            let responseData = await this.$http.getSpecialUser({
                opmSalesperson: 1,
            });
            if (responseData.status == 200) {
                this.userOneList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取字典数据
        async getPartDictionariesData() {
            let responseData = await this.$http.getPartDictionariesData({
                ids: [20, 21],
            });
            if (responseData.status == 200) {
                this.dictionariesData = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },

        // 获取包装信息
        async getPacking(id) {
            var info = "";
            let responseData = await this.$http.getPacking({
                ids: [id],
            });
            if (responseData.status == 200) {
                info = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }

            return info;
        },

        //获取配送方式
        async distributionModes() {
            let responseData = await this.$http.getCateDictionariesData({
                ids: [37],
            });
            if (responseData.status == 200) {
                this.dictionariesDatas = responseData.result;
                // console.log('配送方式',this.dictionariesDatas);
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 判断是不是采购员
        checkIsBuyer() {
            if (this.dataActionBox.actionType != 0) return;
            let info = JSON.parse(sessionStorage.getItem("userInfo"));
            let ormInfo = JSON.parse(sessionStorage.getItem("ormInfo"));
            if (ormInfo.isDefaultopm == 1) {
                if (info.opmSalesperson == 1) {
                    this.sendDataInfo.depName = info.depName;
                    this.sendDataInfo.depId = info.depId;
                    this.sendDataInfo.opmName = info.opmName;
                    this.sendDataInfo.opmId = info.opmId;
                    this.tabForm[0].jurconfigform.forEach((item) => {
                        if (
                            item.entityField == "opmName" ||
                            item.entityField == "depName"
                        )
                            item.isChange = 0;
                    });
                }
            }
        },
        // 获取所有可用库房列表
        async getAllStorageRoom() {
            let responseData = await this.$http.getAllStorageRoom();

            if (responseData.status == 200) {
                this.storageRoomList = responseData.result;
            } else {
                this.$message({
                    message: responseData.message,
                    type: "error",
                });
            }
        },
        // 过滤表单不同类型
        filterMainField() {
            //detaislDataInfo
            var mainFormList = [];
            this.formDataList.forEach((item) => {
                if (item.jciType == 1) {
                    mainFormList.push(item);
                } else if (item.jciType == 2) {
                    this.mxForm = JSON.parse(JSON.stringify(item));
                    this.mxForm.jurconfigform.forEach((item1) => {
                        if (item1.fieldType == "number") {
                            this.$set(this.detaislDataInfo, item1.entityField, 0);
                        } else if (item1.fieldType == "search" && item1.setField) {
                            var arr = item1.setField.split(",");
                            arr.forEach((item2) => {
                                this.$set(this.detaislDataInfo, item2, "");
                            });
                        } else {
                            this.$set(this.detaislDataInfo, item1.entityField, "");
                        }
                    });
                } else if (item.jciType == 3) {
                    this.footForm = JSON.parse(JSON.stringify(item.jurconfigform));
                }
            });
            mainFormList.forEach((key, i) => {
                this.tabForm[i] = JSON.parse(JSON.stringify(key));
                this.tabForm[i].jurconfigform = [];
                var index1 = 0
                for (let index = 0; index < key.jurconfigform.length; index++) {
                    if (key.jurconfigform[index].isShow == 1) {
                        key.jurconfigform[index].isIndex = index1
                        index1++
                    }
                    this.tabForm[i].jurconfigform.push(key.jurconfigform[index]);
                }
            });
            var arr = [{ entityField: "woApplyDetails" }];
            var obj = this.$common.filterMainFields(
                this.formDataList,
                arr,
                mainFormList[0]
            );
            for (let key in obj) {
                this.$set(this.sendDataInfo, key, obj[key]);
            }
            this.$set(this.sendDataInfo, "woamSaledate", this.$moment().valueOf());
            this.$set(this.sendDataInfo, "orderType", 1); //orderType	订单类型0.药品订单1.器械订单
        },
    },
    //生命周期 - 创建完成（可以访问当前this实例）
    created() {
        this.getSpecialUser();
        this.getAllStorageRoom();
        this.getPartDictionariesData();
        this.distributionModes(); //配送
        this.distributionModes(); //配送
        this.$dbCache.Record_Get(4).then((res) => {//选择明细后不允许更换单位
            //明细拦截
            let obj = res
            if (obj.isEnable == 1) this.detailRules = true;
            if (this.sendDataInfo.totalCount > 0 && this.detailRules) {
                this.ruleDisabled = true;
            } else {
                this.ruleDisabled = false;
            }
        });
        this.$nextTick(() => {
            this.openBox();

            this.isLoaded = true;
        });
    },
    //生命周期 - 挂载完成（可以访问DOM元素）
    mounted() {
        document.onkeydown = function () {
            if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                window.event.returnValue = false;
            }
        };
        // addEventListener('keydown', this.keyDown)
        addEventListener("keyup", this.keyUp); //创建监听键盘事件
    },
    beforeDestroy() {
        removeEventListener("keyup", this.keyUp);
    },
    beforeCreate() { }, //生命周期 - 创建之前
    beforeMount() { }, //生命周期 - 挂载之前
    beforeUpdate() { }, //生命周期 - 更新之前
    updated() {
        this.getMainInput();
    }, //生命周期 - 更新之后
    beforeDestroy() { }, //生命周期 - 销毁之前
    destroyed() { }, //生命周期 - 销毁完成
    activated() { }, //如果页面有keep-alive缓存功能，这个函数会触发
};
</script>

<style scoped>
.table_button_box {
    height: 200px;
    background-color: red;
}

.el-row {
    display: flex;
    flex-wrap: wrap;
    padding-right: 20px;
}

.el-drawer {
    outline: none;
}

.el-table .rowStyle {
    background: #fff7ca !important;
}

.dialogBox ::v-deep .el-dialog {
    margin-bottom: 5px !important;
}
</style>